<template>
	<div class="main-table">
		<div class="main-table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				border
				stripe
				:height="tableHeight"
			>
				<el-table-column
					min-width="1000"
					prop="message"
					label="详情"
					align="center">
				</el-table-column>
				<el-table-column
					width="180"
					prop="@timestamp"
					label="时间"
					align="center">
				</el-table-column>
				<el-table-column
					width="180"
					prop="userName"
					label="操作人"
					align="center">
				</el-table-column>
				<el-table-column
					width="140"
					prop="tel"
					label="联系方式"
					align="center">
				</el-table-column>
				<el-table-column
					width="140"
					prop="operationObject"
					label="操作对象"
					align="center">
					<!-- <template slot-scope="scope">
						<div v-if="scope.row.mainMenu">{{scope.row.mainMenu}}-{{scope.row.subMenu}}</div>
					</template> -->
				</el-table-column>
				<el-table-column
					width="120"
					prop="actionType"
					label="操作类型"
					align="center">
				</el-table-column>
			</el-table>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20,40, 60, 100]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		tableData: {
			type: Array
		},
		totalCount: {
			type: Number
		},
		size: {
			type: Number,
			default: 20
		},
		page: {
			type: Number,
			default: 1
		},
		AuthorityList: {
			type: Object
		}
	},
	data () {
		return {
			tableHeight: '100%',
			pagination: {
				page: this.page,
				size: this.size
			}
		}
	},
	created () {
		// this.getAuthority('07_0001_0000_00')
	},
	methods: {
		handleSizeChange (value) {
			this.pagination.size = value
			this.$emit('handleSize', value)
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.$emit('handlePage', value)
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	display flex
	flex: 1
	flex-direction: column
	min-height: 0
	.main-table-box {
		flex: 1
		width: 100%
		// padding-bottom 10px
		box-sizing: border-box;
		overflow: hidden
		overflow-y: auto;
		display flex
		flex-direction: column
	}
	.over-hidden{
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
	.history-status {
		display: flex;
		justify-content: center;
		align-items: center;
		span {
			display: inline-block;
			width: 6px;
			height: 6px;
			background: #60C769;
			border-radius: 50%;
			margin-right: 10px;
		}
	}
}
.preview-box {
	width: 100%;
	text-align: center;
	margin: 10px 0;
	img {
		display: inline-block
	}
}
</style>
<style lang="stylus">
.main-table {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
